export const DISABLE_TYPE_CUT_OFF = "cut off";
export const DISABLE_TYPE_OFF_DAY = "off day";
export const DISABLE_TYPE_NON_WORKING_DAY = "non-working day";
export const DISABLE_TYPE_PROCESSING_DAY = "processing day";
export const DISABLE_TYPE_NOT_AVAILABLE = "not available";

export const DAY = "day";
export const WEEK = "week";
export const MONTH = "month";